import React, { useState } from "react";

const BioSection = ({ bio, color = "black" }) => {
  const [expanded, setExpanded] = useState(false);

  if (!bio) {
    return (
      <div className="mb-4">
        <p className="light-text-profile">Bio</p>
        <p className="dark-profile-text text-muted">No bio added yet.</p>
      </div>
    );
  }

  const MAX_LENGTH = 500;
  const isLong = bio.length > MAX_LENGTH;

  const truncatedText = isLong ? bio.slice(0, MAX_LENGTH) + "..." : bio;
  const displayedText = expanded ? bio : truncatedText;

  return (
    <div className="mb-4">
      <p className="light-text-profile">Bio</p>

      <div className={`bio-text-wrapper ${expanded ? "expanded" : ""}`}>
        <p
          className="dark-profile-text mb-1"
          style={{ whiteSpace: "pre-line", color: color }}
        >
          {displayedText}
        </p>
      </div>

      {isLong && (
        <button
          type="button"
          className="btn btn-link p-0 bio-toggle-btn"
          onClick={() => setExpanded((prev) => !prev)}
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

export default BioSection;
